import { Radius, Spacer } from '@sparemin/blockhead';
import React from 'react';

import {
  TextColorPicker,
  TextSlider,
} from 'components/TextToolbar/TextControls';
import ToolbarPopoverButton from 'components/TextToolbar/ToolbarPopoverButton';
import { textControlsBlock } from 'components/TextToolbar/utils';

import useTextOverlayAdvancedAnimation from '../../../useTextOverlayAdvancedAnimation';
import AnimationControlContainer from '../../AnimationControlContainer';
import { block } from '../../utils';
import {
  BACKGROUND_RADIUS_STEP,
  MAX_BACKGROUND_RADIUS_VW,
  MIN_BACKGROUND_RADIUS_VW,
} from './constants';
import { parseBackgroundRadiusVw } from './utils';

export interface ActiveLineScrollAnimationBackgroundSelectorProps {}

const ActiveLineScrollAnimationBackgroundSelector: React.FC<ActiveLineScrollAnimationBackgroundSelectorProps> = () => {
  const {
    selectedAdvancedAnimation,
    onAnimationPropertyChange,
  } = useTextOverlayAdvancedAnimation();

  const { lineBackgroundColor, lineBackgroundRadius } =
    selectedAdvancedAnimation?.properties ?? {};

  return (
    <AnimationControlContainer title="background">
      <ToolbarPopoverButton
        isEnabled
        minimal
        offset={8}
        placement="top"
        strategy="fixed"
        popoverContent={
          <Spacer
            orientation="vertical"
            space={1}
            className={textControlsBlock('controls-popover-content')}
          >
            <TextColorPicker
              value={lineBackgroundColor}
              onChange={color =>
                onAnimationPropertyChange('lineBackgroundColor', color)
              }
            />
            <TextSlider
              label="Radius"
              minValue={MIN_BACKGROUND_RADIUS_VW}
              maxValue={MAX_BACKGROUND_RADIUS_VW}
              step={BACKGROUND_RADIUS_STEP}
              value={parseBackgroundRadiusVw(lineBackgroundRadius)}
              icon={<Radius />}
              onChange={radius =>
                onAnimationPropertyChange('lineBackgroundRadius', `${radius}vw`)
              }
            />
          </Spacer>
        }
        onClickTrigger={() => undefined}
      >
        <span
          className={block('animation-color-picker')}
          style={{ backgroundColor: lineBackgroundColor }}
        />
      </ToolbarPopoverButton>
    </AnimationControlContainer>
  );
};

export default ActiveLineScrollAnimationBackgroundSelector;
